import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200 pt-14 md:pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <Link to="/" className="inline-block font-heading text-xl font-semibold text-white mb-4 whitespace-nowrap">
              GTBuy Sheet
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed max-w-xs">
              Your ultimate guide to spreadsheet shopping systems. Compare platforms, learn best practices, and shop smarter.
            </p>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-white mb-4">Quick Links</h5>
            <ul className="space-y-2.5">
              <li><a href="/" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Home</a></li>
              <li><a href="/article/what-is-gtbuy-spreadsheet" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Shopping Guide</a></li>
              <li><a href="/#categories" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Categories</a></li>
              <li><a href="/#comparison" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Compare Platforms</a></li>
              <li><a href="/#articles" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">SEO Guides</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-white mb-4">Shop Categories</h5>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Shoes</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">T-Shirts</a></li>
              <li><a href="https://kaspreadsheet.com/search-911/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Jackets</a></li>
              <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Hoodies / Sweaters</a></li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-white mb-4">External Resources</h5>
            <ul className="space-y-2.5">
              <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">GTBuy Sheet Official</a></li>
              <li><a href="/article/what-is-gtbuy-spreadsheet" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Spreadsheet Guide</a></li>
              <li><a href="/article/gtbuy-vs-kakobuy-vs-superbuy" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Platform Comparison</a></li>
              <li><a href="/article/gtbuy-spreadsheet-for-beginners" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer">Beginner Tutorial</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-foreground-800/60">
          <p className="text-xs text-foreground-500 mb-3 sm:mb-0">
            &copy; {new Date().getFullYear()} GTBuy Sheet. All rights reserved. This is an independent guide — not affiliated with any listed platforms.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
              Visit Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}